import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';
import Whynowrite from '../component/whynotwrite';
import Charactor from '../component/character';
import Event from '../component/event';
import Enviroment from '../component/environment';


@withRouter
@inject("store")

export default class ZeroToOne extends Component
{
  character(){
    this.props.store.zerooo = "character";
    this.props.store.zerocharacter = "nothing"
    this.forceUpdate();
  }

  event(){
    this.props.store.zerooo = "event";
    this.props.store.zeroevent = "nothing"
    this.forceUpdate();
  }

  environment(){
    this.props.store.zerooo = "environment";
    this.props.store.zeroenvironment = "nothing";
    this.forceUpdate();
  }

  back(){
    this.props.store.zerooo = "nothing";
    this.props.store.zerocharacter = "nothing";
    this.forceUpdate();

  }
  
    render()
    {
        return <div className = "zero"> {this.props.store.zerooo == "nothing"?<>
            <div className = "zerostart">现在，让我们从头开始写一个小故事<br/>
            有人物，事件，环境三个方向<br/>
            请先随意找寻一下灵感，想想要写什么<br/><br/>
            如果想到的是一个人物，一个角色，请点击人物按钮。<br/>
            如果想到的是一件事情，一个变化的过程，请点击事件按钮<br/>
            如果想到一个地点，场景，请点击环境按钮。<br/>
            (推荐从人物开始)

            </div></>:
           //选择好的情况
            <>
            {/* 如果选了人物*/}
           {this.props.store.zerooo == "character" && <Charactor/>}
           {this.props.store.zerooo == "event" && <Event/>}
           {this.props.store.zerooo == "environment" && <Enviroment/>}
            </>}
        
            <img src={cookie} className="cookiepicture" alt="cookie" />
            {this.props.store.zerooo == "nothing"?<>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >人物</Button><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() }  >事件</Button><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >环境</Button><br/>
            <br/><div className ="zeroend">不用太纠结，<br/>随便选选就行<br/><br/>记得准备好纸笔<br/>或能写作的电子设备</div></>:<>
             {/* 如果选了人物*/}
            <Button icon="refresh" className="back" minimal={true} onClick={()=>this.back() } >重选</Button>
            </>}

    </div>;
    }
} 